export default __webpack_public_path__ + "static/media/promoText.547bd51a.png";